export default __webpack_public_path__ + "static/media/KanipakamTempleOne.ad4df755.png";